// import { translations as travelSafety } from './travelsafety';
import { ROUTE_PATH_PROTECTION } from '../../../constants';
import { ResourceCentrePageTranslations } from '../../types';
// import { translations as generalInfo } from './generalinfo';
// import { translations as infoSecurity } from './infosec';
import { translations as lostItemRecovery } from './recovery';

export const translations: ResourceCentrePageTranslations = {
  docTitle: 'Centre de ressources',
  pageTitle: 'Centre de ressources',
  backToParentPage: {
    to: ROUTE_PATH_PROTECTION,
    exact: true,
    children: 'Retour à la Protection contre la perte du portefeuille'
  },
  categories: {
    lostItemRecovery
    // infoSecurity,
    // travelSafety,
    // generalInfo
  }
};
